export const combinationRules = [
  // --- ขั้นตอนที่ 1: เตรียมวัตถุดิบดิบ (Raw -> Processed) ---
  { ingredients: ['raw_pork', 'action_chop'], result: 'processed_minced_pork' }, // หมูสับ
  { ingredients: ['raw_pork', 'action_grill'], result: 'processed_grilled_pork' }, // หมูย่าง
  { ingredients: ['raw_papaya', 'action_chop'], result: 'processed_papaya_shreds' }, // เส้นมะละกอ
  { ingredients: ['raw_egg', 'action_mix'], result: 'processed_beaten_egg' }, // ไข่เจียวดิบ
  
  // --- ขั้นตอนที่ 2: เตรียมเครื่องปรุง/เครื่องแกง ---
  { ingredients: ['raw_chili', 'raw_garlic', 'action_pound'], result: 'processed_chili_garlic' }, // พริกกระเทียมโขลก
  { ingredients: ['raw_curry_herbs', 'action_pound'], result: 'processed_curry_paste' }, // พริกแกง (ใช้ร่วมกันหลายเมนูเพื่อความง่าย)

  // --- ขั้นตอนที่ 3: ปรุงเมนู (เหนือ) ---
  { ingredients: ['raw_noodles', 'processed_curry_paste', 'raw_chicken', 'action_boil'], result: 'recipe_khao_soi' },
  { ingredients: ['processed_minced_pork', 'raw_tomato', 'action_pound'], result: 'recipe_nam_prik_ong' },
  { ingredients: ['raw_pork', 'processed_curry_paste', 'action_boil'], result: 'recipe_kang_hung_lay' },
  { ingredients: ['raw_noodles', 'processed_minced_pork', 'action_boil'], result: 'recipe_nam_ngiao' },
  { ingredients: ['processed_minced_pork', 'processed_curry_paste', 'action_grill'], result: 'recipe_sai_ua' },

  // --- ขั้นตอนที่ 3: ปรุงเมนู (อีสาน) ---
  { ingredients: ['processed_papaya_shreds', 'processed_chili_garlic', 'action_pound'], result: 'recipe_som_tum' },
  { ingredients: ['processed_minced_pork', 'processed_chili_garlic', 'action_mix'], result: 'recipe_larb_moo' },
  { ingredients: ['raw_pork', 'processed_chili_garlic', 'action_boil'], result: 'recipe_tom_zap' },
  { ingredients: ['processed_grilled_pork', 'action_chop'], result: 'recipe_kor_moo_yang' }, // หั่นหมูย่างเป็นจาน
  { ingredients: ['processed_grilled_pork', 'processed_chili_garlic', 'action_mix'], result: 'recipe_nam_tok_moo' },

  // --- ขั้นตอนที่ 3: ปรุงเมนู (กลาง) ---
  { ingredients: ['raw_shrimp', 'raw_curry_herbs', 'action_boil'], result: 'recipe_tom_yum_goong' },
  { ingredients: ['raw_noodles', 'raw_shrimp', 'action_stir_fry'], result: 'recipe_pad_thai' },
  { ingredients: ['raw_chicken', 'processed_curry_paste', 'action_boil'], result: 'recipe_green_curry' },
  { ingredients: ['processed_minced_pork', 'processed_chili_garlic', 'action_stir_fry'], result: 'recipe_pad_krapow' },
  { ingredients: ['processed_beaten_egg', 'processed_minced_pork', 'action_fry'], result: 'recipe_kai_jeaw' },

  // --- ขั้นตอนที่ 3: ปรุงเมนู (ใต้) ---
  { ingredients: ['processed_minced_pork', 'processed_curry_paste', 'action_stir_fry'], result: 'recipe_kua_kling' },
  { ingredients: ['raw_shrimp', 'processed_curry_paste', 'action_boil'], result: 'recipe_kang_som' },
  { ingredients: ['raw_shrimp', 'raw_sato', 'action_stir_fry'], result: 'recipe_pad_sato' },
  { ingredients: ['raw_chicken', 'raw_curry_herbs', 'action_boil'], result: 'recipe_gai_tom_kamin' },
  { ingredients: ['raw_pork', 'raw_garlic', 'action_boil'], result: 'recipe_moo_hong' }
];